<template>
  <div class="order-confirm-right-fixed">
    <div class="header-box">
      <div class="header-title">费用明细</div>
    </div>
    <div class="body-box">
      <!-- 特价商品时限说明 -->
      <div class="special-price-date-explain" v-if="order.special_price">
        该特价商品将在 <span>{{specialEndDate}}</span> 后恢复原价
      </div>
      <div class="price-list">
        <div class="price-item">
          <div class="item-left">
            <div class="item-label">商品金额</div>
            <div class="left-price">
              <div class="single-price">
                <base-price-text
                  color="#2F333D"
                  font-weight="400"
                  :price="order.special_price ? order.special_price : order.applicant[0].sell_price"
                  :styleOption="priceStyleOption"
                ></base-price-text>
              </div>
              <div class="price-num"> x {{order.applicant.length}}</div>
            </div>
          </div>
          <div class="item-right">
            <div class="original-price" v-if="order.special_price">
              ¥{{order.peer_price * order.applicant.length / 100}}
            </div>
            <div class="right-price">
              <base-price-text
                color="#2F333D"
                font-weight="400"
                :price="orderVisaPriceTotal"
                :styleOption="priceStyleOption"
              ></base-price-text>
            </div>
          </div>
        </div>


        <div class="price-item" v-if="sfChecked && pickupAmount">
          <div class="item-left">
            <div class="item-label">顺丰上门取资料服务</div>
          </div>
          <div class="item-right">
            <div class="right-price">
              <base-price-text
                color="#2F333D"
                font-weight="400"
                :price="pickupAmount"
                :styleOption="priceStyleOption"
              ></base-price-text>
            </div>
          </div>
        </div>

        <div class="price-item" v-if="sfReturnExpressPrice">
          <div class="item-left">
            <div class="item-label">顺丰回寄运费</div>
          </div>
          <div class="item-right">
            <div class="right-price">
              <base-price-text
                color="#2F333D"
                font-weight="400"
                :price="sfReturnExpressPrice"
                :styleOption="priceStyleOption"
              ></base-price-text>
            </div>
          </div>
        </div>

        <!-- 用户保险 -->
        <div class="price-item" v-if="order.product_insurance_new && order.product_insurance_new[0].insurance_type === 1 && userInsurance" >
          <div class="item-left">
            <div class="item-label">旅游保险</div>
            <div class="left-price">
              <div class="single-price">
                <base-price-text
                  color="#2F333D"
                  font-weight="400"
                  :price="userInsurance.insurance_fee * userInsurance.insurance_discount / order.applicant.length"
                  :styleOption="priceStyleOption"
                ></base-price-text>
              </div>
              <div class="price-num"> x {{order.applicant.length}}</div>
            </div>
          </div>
          <div class="item-right">
            <div class="right-price">
              <base-price-text
                color="#2F333D"
                font-weight="400"
                :price="userInsurance.insurance_fee * userInsurance.insurance_discount"
                :styleOption="priceStyleOption"
              ></base-price-text>
            </div>
          </div>
        </div>

        <!-- 平台 -->
        <div class="price-item" v-if="order.product_insurance_new && order.product_insurance_new[0].insurance_type === 2" >
          <div class="item-left">
            <div class="item-label">旅游保险</div>
            <div class="left-price">
              <div class="single-price">
                <base-price-text
                  color="#2F333D"
                  font-weight="400"
                  :price="platInsurance.insurance_fee"
                  :styleOption="priceStyleOption"
                ></base-price-text>
              </div>
              <div class="price-num"> x {{order.applicant.length}}</div>
            </div>
          </div>
          <div class="item-right">
            <div class="right-price">
              <base-price-text
                color="#2F333D"
                font-weight="400"
                :price="platInsurance.insurance_fee * order.applicant.length"
                :styleOption="priceStyleOption"
              ></base-price-text>
            </div>
          </div>
        </div>

        <!-- 供应商保险 -->
        <div class="price-item" v-if="order.product_insurance && order.product_insurance.insurance_type === 3" >
          <div class="item-left">
            <div class="item-label">旅游保险</div>
            <div class="left-price">
              <div class="single-price">
                <base-price-text
                  color="#2F333D"
                  font-weight="400"
                  :price="0"
                  :styleOption="priceStyleOption"
                ></base-price-text>
              </div>
              <div class="price-num"> x {{order.applicant.length}}</div>
            </div>
          </div>
          <div class="item-right">
            <div class="right-price">
              <base-price-text
                color="#2F333D"
                font-weight="400"
                :price="0"
                :styleOption="priceStyleOption"
              ></base-price-text>
            </div>
          </div>
        </div>

        <div class="price-item" v-if="showRejectProductModule" >
          <div class="item-left">
            <div class="item-label">拒签无忧</div>
            <div class="left-price">
              <div class="single-price">
                <base-price-text
                  color="#2F333D"
                  font-weight="400"
                  :price="rejectProductPrice / order.applicant.length"
                  :styleOption="priceStyleOption"
                ></base-price-text>
              </div>
              <div class="price-num"> x {{order.applicant.length}}</div>
            </div>
          </div>
          <div class="item-right">
            <div class="right-price">
              <base-price-text
                color="#2F333D"
                font-weight="400"
                :price="rejectProductPrice"
                :styleOption="priceStyleOption"
              ></base-price-text>
            </div>
          </div>
        </div>

        <div class="price-item coupon-item" v-if="orderSelectedCoupon && orderSelectedCoupon.id && !order.special_price" >
          <div class="item-left">
            <div class="item-label">优惠券</div>
          </div>
          <div class="item-right">
            <div class="right-price is-red">
              <base-price-text
                font-weight="400"
                :price="couponReducePrice"
                :styleOption="priceStyleOption"
              >
                <template #left><span style="font-size: 14px;line-height:16px;">- </span></template>
              </base-price-text>
            </div>
          </div>
        </div>
      </div>


      <div class="sum-box">
        <div class="sum-price">
          <div class="sum-label">应付金额</div>
          <div class="sum-num">
            <base-price-text
              :price="totalAmount"
              :styleOption="{
                currency: 'font-size: 14px;line-height:16px;margin-right: 2px;',
                integer: 'font-size: 20px;line-height:18px;',
                decimal: 'font-size: 16px;',
              }"
            ></base-price-text>
          </div>
        </div>
      </div>
    </div>
  
  </div>
</template>

<script>
import BasePriceText from './base/base-price-text.vue';

export default {
  components: {
    BasePriceText,
  },
  props: {
    order: {
      type: Object,
      required: true,
      default: () => ({}),
    },
    totalAmount: {
      type: Number,
    },
    orderVisaPriceTotal: Number,
    sfChecked: Boolean,
    pickupAmount: Number,
    sfReturnExpressPrice: Number,
    userInsurance: {
      type: Object,
    },
    platInsurance: {
      type: Object,
    },
    rejectProductPrice: {
      type: Number,
      required: false,
      default: 0,
    },
    showRejectProductModule: {
      type: Boolean,
      default: false,
    },
    orderSelectedCoupon: {
      type: Object,
      required: true,
      default: () => ({}),
    },
    couponReducePrice: Number, // 优惠券实际减免金额
  },
  data() {
    return {};
  },
  computed: {
    // 特价截止日期
    specialEndDate() {
      const dateArray = this.order.special_end_date.split('-');
      return `${dateArray[0]}年${dateArray[1]}月${dateArray[2]}日`;
    },
    priceStyleOption() {
      return {
        currency: 'font-size: 14px;line-height:14px;',
        integer: 'font-size: 14px;line-height:14px;',
        decimal: 'font-size: 12px;line-height:12px;',
      };
    },
  },
  created() {},
  methods: {},
};
</script>

<style lang="less" scoped>
.order-confirm-right-fixed {
  width: 300px;
  background: #FFFFFF;
  box-shadow: 0px 2px 4px 0px rgba(0,0,0,0.06);
  border-radius: 2px;
  line-height: 1;
  .header-box {
    height: 50px;
    display: flex;
    align-items: center;
    border-bottom: 1px solid #F0F0F0;
    padding: 0 20px;
    .header-title {
      color: #444444;
      font-size: 16px;
      font-weight: 600;
    }
  }

  .body-box {
    padding: 16px 20px 0 20px;

    .special-price-date-explain {
      background: rgba(255,128,51,0.08);
      padding: 0 7px;
      font-size: 12px;
      height: 20px;
      display: inline-flex;
      align-items: center;
      color: #2F333D;
      border-radius: 20px;
      margin: 0 auto 8px auto;
      span{
        color: #FF8033;
      }
    }

    .price-list {
      padding-bottom: 20px;
      .price-item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 12px;
        color: #2F333D;
        font-size: 14px;
        &:last-child{
          margin-bottom: 0;
        }
        &.coupon-item{
          margin-top: 20px;
        }
        .item-left {
          display: flex;
          align-items: center;
          .item-label {
            line-height: 18px;
          }

          .left-price {
            margin-left: 4px;
            display: flex;
            align-items: center;
            .single-price {
              color: #2F333D;
            }

            .price-num {
              margin-left: 4px;
              color: #91999F;
            }
          }
        }

        .item-right {
          display: flex;
          align-items: center;
          .original-price{
            color: #91999F;
            text-decoration: line-through;
            margin-right: 5px;
          }
          .right-price {
            color: #2F333D;
            &.is-red{
              color: #FF8033;
            }
          }
        }
      }
    }

    .sum-box{
      border-top: 1px dashed #DEE2E6;
      padding: 20px 0;
      .sum-price{
        display: flex;
        align-items: center;
        justify-content: space-between;
        .sum-label{
          color: #2F333D;
          font-size: 14px;
          font-weight: 600;
        }
        .sum-num{
          color: #FF8033;
          font-weight: 600;
        }
      }
    }
  }


}
</style>



// WEBPACK FOOTER //
// src/pages/ordering/components/order-confirm-right-fixed.vue